import { NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, ViewEncapsulation, computed, inject } from '@angular/core';
import { TranslatePipe, TranslationService } from '../../../core/i18n';
import { AppConfigService } from './app-config.service';
import { resolveShellHeroLink } from './resolve-shell-hero-link';

type BannerLanguage = 'EN' | 'FR';

/** Responsive, localized marketing hero shown above routed page content. */
@Component({
  selector: 'app-shell-hero',
  imports: [NgTemplateOutlet, TranslatePipe],
  templateUrl: './shell-hero.html',
  styleUrl: './shell-hero.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-shell__hero',
    role: 'region',
  },
})
export class ShellHero {
  private readonly translation = inject(TranslationService);
  private readonly appConfig = inject(AppConfigService);

  constructor() {
    this.appConfig.ensureLoaded();
  }

  protected readonly bannerLanguage = computed<BannerLanguage>(() =>
    this.translation.locale() === 'fr' ? 'FR' : 'EN',
  );

  protected readonly desktopWebpSource = computed(
    () => `/app-config/${this.bannerLanguage()}_Web-Banner_2000x430.webp`,
  );

  protected readonly mobileWebpSource = computed(
    () => `/app-config/${this.bannerLanguage()}_Web-Banner_720x472.webp`,
  );

  protected readonly heroLink = computed(() =>
    resolveShellHeroLink(this.appConfig.config(), this.translation.locale()),
  );

  /** Localized accessible name for the marketing region. */
  @HostBinding('attr.aria-label')
  get ariaLabel(): string {
    return this.translation.translate('layout.hero.ariaLabel');
  }
}
